export default {
  addressForm: state => state.address,
  billing_address: state => state.billing_address,
  paymentForm: state => state.payment_info,
  contactForm: state => state.contact,
  canContinueAddress (state) {
    if (state.address.billingDifferent) return Boolean(state.billing_address.company_name && state.address.company_name)
    return Boolean( state.address.company_name)
  },
  canContinuePayment (state) {
    if (state.payment_info.payLater) return Boolean (state.payment_info.poNumber && !state.payment_info.poNumberExisted )
      return Boolean(
        state.payment_info.nameOnCard &&
        state.payment_info.cardNumber &&
        state.payment_info.expMonth &&
        state.payment_info.expYear &&
        state.payment_info.cvv&&
        state.payment_info.poNumber && 
        !state.payment_info.poNumberExisted 
      )
  },
  hasAcceptedItems: state => state.hasAcceptedItems,
  hasAnyAccepted: state => state.hasAnyAccepted,
  allow_pay_later: state => state.checkout_settings.allow_pay_later,
  contact_name_required: state => state.checkout_settings.contact_name_required,
  contact_phone_required: state => state.checkout_settings.contact_phone_required,
  total_order: state => state.total_order
}